
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'Apple'
})
export default class Apple extends Vue {}
